import { render, staticRenderFns } from "./notice-channel.vue?vue&type=template&id=1c85185a&scoped=true"
import script from "./notice-channel.vue?vue&type=script&lang=ts"
export * from "./notice-channel.vue?vue&type=script&lang=ts"
import style0 from "./notice-channel.vue?vue&type=style&index=0&id=1c85185a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85185a",
  null
  
)

export default component.exports